window.jQuery = window.$ = require('jquery');
var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('base/components/menu'));
    processInclude(require('base/components/consentTracking'));
    processInclude(require('base/components/footer'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('base/components/clientSideValidation'));
    processInclude(require('base/components/countrySelector'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('jquery-validation/dist/jquery.validate.min.js'));
    processInclude(require('./globalValidation'));
    processInclude(require('./components/menu'));
    processInclude(require('./components/balanceInfoWidget'));
    processInclude(require('./components/footer'));
    processInclude(require('./components/miniCart'));
    processInclude(require('./page/home/selectionFooter'));
    processInclude(require('./components/search'));
    processInclude(require('./components/sessionRedirect'));
    processInclude(require('./components/winShopSwitcher'));
    processInclude(require('./components/signupBadge'));
    processInclude(require('./analytics'));
    processInclude(require('./components/newLoader'));
});

require('base/thirdParty/bootstrap');
require('./components/spinner');
require('./components/toastrService');

if ($('.new-confirmation-full-animation').length > 0) {
    setTimeout(function(){
        $('.new-confirmation-full-animation').removeClass('show');
    }, 3000);
}
